// extracted by mini-css-extract-plugin
export default {"headerBlock":"H1yR1","titles":"ggTJN","title":"uF1kz","subtitle":"HDody","gosuslugiButton":"ygl7J"};